import { basename } from '../utils/config'

const urlBase64ToUint8Array = (base64str: string) => {
  const padding = '='.repeat((4 - base64str.length % 4) % 4)
  const raw = atob((base64str + padding).replace(/-/g, '+').replace(/_/g, '/'))
  const outs = new Uint8Array(raw.length)
  for (let i = 0; i < raw.length; ++i) outs[i] = raw.charCodeAt(i)
  return outs
}

const getAlreadySubscription = async () => {
  const registration = await navigator.serviceWorker.register('sw.js')
  return await registration.pushManager.getSubscription()
}
export const mkSearchSubscriptionParams = async () => {
  const subsc = await getAlreadySubscription()
  if (! subsc) return null
  const keys = JSON.parse(JSON.stringify(subsc)).keys
  return new URLSearchParams(keys)
}

export const serviceWorkerSet = async () => {
  const registration = await navigator.serviceWorker.register('sw.js')
  const subscription = await registration.pushManager.getSubscription()
  if (subscription) return subscription
  else {
    const response = await fetch('') // TODO: vapid_publickeyのURLを指定
    const vapid_publickey = await response.text()
    const applicationServerKey = urlBase64ToUint8Array(vapid_publickey)
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true, applicationServerKey
    })
    return subscription
  }
}
// ここから上まだ利用していない（webpush登録の際に利用） //

export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register(`${basename}sw.js`, { scope: `${basename}` })
    })
  }
}
